var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:[
    'wb-button',
    `wb-button--${_vm.type}`,
    `wb-button--medium`,
    { 'wb-button--theme-dark': _vm.isDarkModeOn },
  ],attrs:{"href":_vm.url,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }